import React from "react";

const Certifications = () => {
	return (
		<section className="section">
			<h2>Certifications</h2>
			<div className="flex">
				<article className="flex-item">
					<h3>AWS Certified Cloud Practitioner</h3>
					<p>
						Amazon Web Services (AWS)
						<br />
						Issued: June 2020
						<br />
						Credential ID: DKYNRT32PEREQC3G
						<br />
						<a href="https://aws.amazon.com/verification">
							Validate Credential
						</a>
					</p>
				</article>
				<article className="flex-item">
					<h3>AWS Certified Solutions Architect - Associate</h3>
					<p>
						Amazon Web Services (AWS)
						<br />
						Issued: June 2020
						<br />
						Credential ID: 90NJH47KN2F41XK9
						<br />
						<a href="https://aws.amazon.com/verification">
							Validate Credential
						</a>
					</p>
				</article>
			</div>
			<div className="flex">
				<article className="flex-item">
					<h3>Puppet Professional 2016</h3>
					<p>
						Puppet
						<br />
						Issued: October 2016
						<br />
					</p>
				</article>
				<article className="flex-item">
					<h3>
						VCP6-CMA (VMware Certified Professional 6 - Cloud Management and
						Automation)
					</h3>
					<p>
						VMware
						<br />
						Issued: September 2016
						<br />
					</p>
				</article>
			</div>
			<div className="flex">
				<article className="flex-item">
					<h3>SCPU - Splunk Certified Power User 6.3</h3>
					<p>
						Splunk
						<br />
						Issued: June 2016
						<br />
					</p>
				</article>
				<article className="flex-item">
					<h3>SPLKA-6 - Splunk Administrator - Version 6.3</h3>
					<p>
						Splunk
						<br />
						Issued: June 2016
						<br />
					</p>
				</article>
			</div>
			<div className="flex">
				<article className="flex-item">
					<h3>CloudBees Jenkins Platform Engineer</h3>
					<p>
						Cloudbees
						<br />
						Issued: May 2016
						<br />
						Credential ID: 10198365
						<br />
						<a href="https://certificates.cloudbees.com/10198365">
							Validate Credential
						</a>
					</p>
				</article>
				<article className="flex-item">
					<h3>Jenkins Engineer</h3>
					<p>
						Jenkins project
						<br />
						Issued: May 2016
						<br />
						Credential ID: 10198381
						<br />
						<a href="https://certificates.cloudbees.com/10198381">
							Validate Credential
						</a>
					</p>
				</article>
			</div>
			<div className="flex">
				<article className="flex-item">
					<h3>SaltStack Certified Engineer (SSCE)</h3>
					<p>
						SaltStack
						<br />
						Issued: April 2016
						<br />
					</p>
				</article>
				<article className="flex-item">
					<h3>MCITP/MCSA</h3>
					<p>
						Microsoft
						<br />
						Issued: April 2013
						<br />
						Credential ID: 7721878
						<br />
					</p>
				</article>
			</div>
		</section>
	);
};

export default Certifications;
